// import store from '../Redux/store'
// import { updateAuthToken, logoutAction } from '../Redux/actions'
// import { push } from 'connected-react-router'
import Api from './api'

// let is_refreshing = false
// let pool = []

export default class OdooApi {


    static search_read(model, fields=['name']) {
        return new Promise((res, rej) => {

            const headers = {
                'Content-Type': 'application/json',
                // 'Accept': 'application/json, text/javascript, */*; q=0.01'
            }

            const body = {
                "params":
                {
                    "model": model,
                    "fields": fields,
                    "domain": [],
                    "context":
                    {
                        "lang": "en_US",
                        "tz": "America/New_York",
                        "uid": 1,
                        "params":
                        {
                            // "action": 272
                        }
                    },
                    "offset": 0,
                    "limit": 100,
                    "sort": ""
                }
            }

            fetch('/evv/search_read', {
                method: 'POST',
                headers,
                body: JSON.stringify(body)
            })
                .then(response => {
                    return response.json()
                })
                .then(json => {
                    res(json)
                })
                .catch(e => {
                    rej(e)
                })
        })
    }

    // static check_if_online() {

    //     return OdooApi.get_new_service_log_url()
    // }

    static get_new_service_log_url(){
        // const base_url = process.env.REACT_APP_API_PROTOCOL + '://' + window.location.hostname
        return Api.get('/evv/get_new_service_log_url', null, false)
    }
}